import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { withSnackbar } from 'notistack';
import Typography from '@material-ui/core/Typography';
import FormControl from '@material-ui/core/FormControl';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import IconButton from '@material-ui/core/IconButton';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { FormField, AlertHelpDialog } from '@iris-platform/iris-react-ui';
import { HasPermission } from '@iris-platform/protektor';
import {
  append,
  equals,
  findIndex,
  map,
  omit,
  path,
  propEq,
  split,
  curry,
} from 'ramda';
// import { TeamContext } from '../../TeamProvider';
import applicationPropType from '../applicationPropType';
import {
  stylesToPropType,
} from '../../../utils';
import Helpfile from '../helpfile.json';
import { PROTEKTOR_UPDATE } from '../../../utils/protektorConstants';

const SECRET_TTL_MS = 60000;
const KNOWN_PROVIDERS = Object.freeze([
  'email:Email',
  'github:GitHub',
  'facebook:Facebook',
  'comcastsso:Comcast SSO',
]);

const styles = () => ({
  root: {
    width: '100%',
    marginLeft: '0px !important',
  },
  saveButton: {
    borderRadius: '0.125em',
    marginTop: '1em',
    width: '5em',
  },
  disabledField: {
    cursor: 'default',
    '& *': {
      color: '#606060',
    },
  },
  endAdornment: {
    marginRight: '0.5em',
  },
  expiring: {
    position: 'relative',
    zIndex: 0,
    '& svg.timer': {
      zIndex: 0,
      position: 'absolute',
      top: '-0.63em',
      left: '-0.63em',
      height: '2.9em',
      width: '2.9em',
      transform: 'rotate(-90deg)',
      '& circle': {
        stroke: '#d2d2d28f',
        strokeWidth: '40',
        fill: 'none',
        strokeDasharray: '126 252',
        animation: `wipe ${SECRET_TTL_MS / 1000}s linear`,
      },
    },
    '& svg:not(.timer)': {
      zIndex: 1,
      position: 'sticky',
    },
  },
  divider: {
    margin: '2em 0',
  },
  textField: {
    height: 'auto',
    paddingLeft: '0.5em',
    '&::before, &:hover::before': {
      display: 'none !important',
    },
  },
  button: {
    borderRadius: '0.125em',
    marginTop: '1em',
    marginRight: '0em',
    width: '8em',
  },
  icon: {
    // margin: theme.spacing.unit,
    fontSize: 14,
    cursor: 'pointer',
  },
  iconbutton: {
    width: '18px',
    height: '18px',
  },
  resetContainer: {
    display: 'flex',
    flexFlow: 'row wrap',
    justifyContent: 'space-between',
    alignItems: 'center',
    '& [class^="FormField"]': {
      flexGrow: '0.95',
    },
  },
  warning: {
    color: '#f50057',
  },
  '@keyframes wipe': {
    '0%': {
      strokeDashoffset: 0,
    },
    '100%': {
      strokeDashoffset: -126,
    },
  },
  switchContainer: {
    marginLeft: '24px',
  },
});

class Providers extends Component {
  constructor(props) {
    super(props);

    const { application } = props;
    this.state = {
      application: {
        applicationID: application.applicationID,
        oauth2Providers:
          application.oauth2Providers === undefined
            ? []
            : application.oauth2Providers,
      },
      title: 'Providers',
      error: null,
      pendingChanges: null,
      saving: false,
      open: false,
      dialogTitle: '',
      dialogContent: '',
    };
  }

  handleHelpOpen = (title, content) => {
    this.setState({
      open: true,
      dialogTitle: title,
      dialogContent: content,
    });
  };

  handleHelpClose = () => {
    this.setState({
      open: false,
      dialogTitle: '',
      dialogContent: '',
    });
  };

  // saveChanges = async () => {
  saveChanges = () => {
    const { ownerId, refreshApp, enqueueSnackbar } = this.props;
    const {
      application: {
        applicationID,
        oauth2Providers,
      },
    } = this.state;
    // const currentTeam = TeamContext.getSelectedTeamId();
    const currentTeam = ownerId;
    const application = {
      applicationID,
      oauth2Providers,
    };

    this.setState({ saving: true });

    refreshApp(application, currentTeam);

    enqueueSnackbar('Providers updated', { variant: 'success' });

    this.setState({ pendingChanges: false });
    this.setState({ saving: false });
  }

  updateAndSave = () => {
    const {
      application: {
        applicationID,
        oauth2Providers,
      },
    } = this.state;

    const providerList = [...oauth2Providers];
    const providerState = [];
    Object.keys(providerList).forEach((prop) => {
      if (!equals(false, providerList[prop].enabled)) {
        const tempState = {};
        tempState.type = providerList[prop].type;
        tempState.clientID = providerList[prop].clientID;
        tempState.clientSecret = providerList[prop].clientSecret;
        providerState.push(tempState);
      }
    });

    const state = { ...this.state };
    state.application = omit(['oauth2Providers'], state.application);
    this.setState({
      application: { applicationID, oauth2Providers: providerState },
    }, () => { this.saveChanges(); });
  }

  toggleEnabled = (key) => {
    const {
      application: {
        applicationID,
        oauth2Providers,
      },
    } = this.state;
    let keyIndex = -1;
    if (oauth2Providers !== undefined && oauth2Providers !== null) {
      keyIndex = findIndex(propEq('type', key))(oauth2Providers);
    }

    let provider = {
      type: key,
      clientID: '',
      clientSecret: '',
      enabled: false,
    };
    if (keyIndex >= 0) {
      provider = { ...oauth2Providers[keyIndex] };
      if (provider.enabled === undefined) provider.enabled = true;
    }
    // console.log(`Provider set: ${JSON.stringify(provider, null, 2)}`);
    provider.enabled = !provider.enabled;
    provider.showFields = provider.enabled;

    let providers = [];
    if (oauth2Providers !== undefined && oauth2Providers !== null && oauth2Providers !== []) {
      providers = [...oauth2Providers];
    }
    if (keyIndex >= 0) {
      providers[keyIndex] = provider;
    } else {
      providers = append(provider, providers);
    }

    this.setState({
      application: { applicationID, oauth2Providers: providers },
      pendingChanges: true,
    });
  };

  handleClientChange = (component, field, event) => {
    const {
      application: {
        applicationID,
        oauth2Providers,
      },
    } = this.state;

    const fieldValue = path(['target', 'value'], event);
    const provider = { ...component };
    provider[field] = fieldValue;
    let keyIndex = -1;
    if (oauth2Providers !== undefined && oauth2Providers !== null) {
      keyIndex = findIndex(propEq('type', provider.type))(oauth2Providers);
    }

    let providers = [];
    if (oauth2Providers !== undefined && oauth2Providers !== null && oauth2Providers !== []) {
      providers = [...oauth2Providers];
    }
    if (keyIndex >= 0) {
      providers[keyIndex] = provider;
    } else {
      providers = append(provider, providers);
    }
    this.setState({
      application: { applicationID, oauth2Providers: providers },
      pendingChanges: true,
    });
  };

  disableInput = () => {}

  providerPanel = (provider, displayName, role) => {
    const { classes } = this.props;
    const { error } = this.state;
    const {
      type,
      enabled,
      clientID,
      clientSecret,
    } = provider;

    return (
      <Fragment key={type}>
        <Typography
          component="div"
          variant="caption"
          gutterBottom
        >
          {displayName}
        </Typography>

        <FormControlLabel
          control={(
            <Switch
              checked={enabled}
              onChange={() => { this.toggleEnabled(type); }}
              value="enable-provider"
              color="primary"
              id={`${type}_sw`}
              key={`${type}_sw`}
              disabled={!role.hasPermission({ action: PROTEKTOR_UPDATE, resource: 'Application_OAuth2_Tab_Providers' })}
            />
          )}
          label={provider.enabled ? 'enabled' : 'disabled'}
        />

        {
          provider.showFields && provider.type !== 'email'
            ? (
              <div>
                <FormControl className={classes.root} error={error}>
                  <FormField
                    placeholder="Enter Client ID"
                    inputClasses={{ input: classes.disabledField }}
                    value={clientID}
                    id={`${type}_id`}
                    key={`${type}_id`}
                    // disabled={!enabled}
                    onChange={(event) => { this.handleClientChange(provider, 'clientID', event); }}
                  />
                </FormControl>
                <FormControl className={classes.root} error={error}>
                  <FormField
                    placeholder="Enter Client Secret"
                    inputClasses={{ input: classes.disabledFieldng }}
                    value={clientSecret}
                    id={`${type}_secret`}
                    key={`${type}_secret`}
                    // disabled={!enabled}
                    onChange={(event) => { this.handleClientChange(provider, 'clientSecret', event); }}
                  />
                </FormControl>
              </div>
            ) : null
        }
        <br />
      </Fragment>
    );
  }

  /* eslint "react/sort-comp": 0 */
  displayValues = curry((role, obj) => {
    const {
      application: {
        oauth2Providers,
      },
    } = this.state;
    const provider = split(':', obj);
    const providerAbbr = provider[0];
    const providerDisp = provider[1];

    let oauthData = {
      enabled: false,
      showFields: false,
      type: providerAbbr,
      clientID: '',
      clientSecret: '',
    };

    if (oauth2Providers !== undefined && oauth2Providers !== null) {
      Object.keys(oauth2Providers).forEach((prop) => {
        if (equals(providerAbbr, oauth2Providers[prop].type)) {
          oauthData = { ...oauth2Providers[prop] };
          if (oauthData.enabled === undefined) oauthData.enabled = true;
          if (oauthData.showFields === undefined) oauthData.showFields = false;
        }
      });
    }
    return this.providerPanel(oauthData, providerDisp, role);
  });

  render() {
    const { classes, role } = this.props;
    const {
      title,
      error,
      pendingChanges,
      open,
      dialogTitle,
      dialogContent,
    } = this.state;
    const help = Helpfile.oauth20;

    const displayValues = this.displayValues(role);

    return (
      <Fragment>
        <form>
          <FormControl className={classes.root} error={error}>
            <Typography
              component="div"
              variant="subheading"
              gutterBottom
            >
              {title}
              <IconButton className={classes.iconbutton} aria-label="Delete" onClick={() => this.handleHelpOpen(help.providers.title, help.providers.content)}>
                <HelpOutlineIcon className={classes.icon} />
              </IconButton>
            </Typography>
            <br />
          </FormControl>

          {map(displayValues, KNOWN_PROVIDERS)}
          <br />

          <FormControl className={classes.root} error={error}>
            <HasPermission
              to={PROTEKTOR_UPDATE}
              access="Application_OAuth2_Tab_Providers"
              forRole={role}
            >
              <Button
                variant="contained"
                classes={{ root: classes.saveButton }}
                disabled={!pendingChanges}
                onClick={this.updateAndSave}
              >
                Save
              </Button>
            </HasPermission>
          </FormControl>
        </form>
        <AlertHelpDialog
          handleClose={this.handleHelpClose}
          open={open}
          dialogTitle={dialogTitle}
          dialogContent={dialogContent}
        />
      </Fragment>
    );
  }
}

Providers.propTypes = {
  application: applicationPropType.isRequired,
  classes: stylesToPropType(styles()).isRequired,
  onChange: PropTypes.func,
  ownerId: PropTypes.string.isRequired,
  refreshApp: PropTypes.func.isRequired,
  role: PropTypes.object.isRequired,
};

Providers.defaultProps = {
  onChange: () => {},
};

// export default withApollo(withStyles(styles)(Providers));
export default withSnackbar(withStyles(styles)(Providers));
